










































import { Component, Watch } from 'vue-property-decorator'
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import DepositAccountSummary from '@/models/Accounts/DepositAccounts/DepositAccountSummary';
import AccountState from '@/components/Accounts/Shared/AccountState.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import FilterAccountsRequest from '@/models/Shared/FilterAccountsRequest';
import AccountSearchType from '@/models/Shared/AccountSearchType';
import ListUtils from '@/lib/listUtils';
import PayeeType from '@/models/Accounts/Shared/Payees/PayeeType';
import { Debounce } from 'vue-debounce-decorator';

@Component({ name: 'DepositAccounts', components: { Alert, AccountState }, metaInfo: { title: 'Deposit Accounts' } })
export default class extends SaascadaVue {

    PayeeType = PayeeType;

    headers = [
        { text: this.$t('pageText.depositAccounts.fields.accountName'), sortable: false, width: "35%" },
        { text: this.accountColumnHeader, sortable: false, width: "15%" },
        { text: this.$t('pageText.depositAccounts.fields.productIssue'), sortable: false, width: "25%" },
        { text: this.$t('pageText.depositAccounts.fields.productSubType'), sortable: false, width: "15%" },
        { text: this.$t('pageText.depositAccounts.fields.state'), sortable: false, width: "10%" }
    ];
    accountsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.accountsPage = +page;
        }
    }

    async beforeMount() {
        const request = new FilterAccountsRequest();
        request.pageNumber = this.accountsPage;
        await DepositAccountModule.getDepositAccounts(request);
    }

    get accounts() {
        return DepositAccountModule.depositAccounts;
    }

    get searchTypeOptions() {
        return ListUtils.accountSearchTypeOptions();
    }

    get totalAccountsPages() {
        return DepositAccountModule.totalDepositAccountsPages;
    }

    get search() {
        return DepositAccountModule.depositAccountsSearch;
    }

    set search(searchText: string) {
        DepositAccountModule.updateDepositAccountsSearch(searchText);
    }

    get searchType() {
        return DepositAccountModule.depositAccountsSearchType;
    }

    set searchType(searchType: AccountSearchType) {
        DepositAccountModule.updateDepositAccountsSearchType(searchType);
    }

    get loading() {
        return DepositAccountModule.loadingDepositAccounts;
    }

    get pageSize() {
        return DepositAccountModule.pageSize;
    }

    get accountColumnHeader() {
        // Get the heading for the account column in the table, depending on what payee types are available
        if (this.availablePayeeTypes.includes(PayeeType.UK)) {
            return this.$t('pageText.depositAccounts.fields.accountNumber');
        }
        else {
            return this.$t('pageText.depositAccounts.fields.iban');
        }
    }

    get availablePayeeTypes() {
        // TODO: This is currently taken from the go backend hardcoded field for AvailablePayeeTypes
        // But once this has been added to the main config the function can be swapped for just "institution.availablePayeeTypes"
        return AuthModule.me.institution.config.availablePayeeTypes;
    }

    @Watch('accountsPage')
    async onAccountsPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.accountsPage}` } });
        // Get new deposit accounts
        const request = new FilterAccountsRequest();
        request.pageNumber = this.accountsPage;
        await DepositAccountModule.getDepositAccounts(request);
    }

    @Watch('searchType')
    async searchTypeChanged() {
        // If the search is not empty we need to clear it, otherwise do nothing
        if (this.search !== '') {
            this.search = '';
            // Then get all accounts with no search or pagination
            const request = new FilterAccountsRequest();
            request.pageNumber = 1;
            await DepositAccountModule.getDepositAccounts(request);
        }
    }

    // Wait before auto-searching to allow the user to type more
    @Debounce(500)
    @Watch("search", { immediate: false, deep: true })
    async searchChanged() {
        const request = new FilterAccountsRequest();

        // Reset back to the first page when searching
        request.pageNumber = 1;
        this.accountsPage = 1;

        await DepositAccountModule.getDepositAccounts(request);
    }

    async navigateToDepositAccount(account: DepositAccountSummary) {
        this.$router.push({ name: PageNames.DepositAccount, params: { id: account.id }, query: { tab: "0" } });
    }

}
